import {
  ShareId,
  IShareProps,
  FacebookURLBuilder,
  LinkedInURLBuilder,
  TwitterURLBuilder
} from './SocialUrlBuilders'

export * from './constants'
export * from './merge'
export * from './types'

export function getShareUrl(type: ShareId, props: IShareProps): string {
  let url = ''

  if (type === 'Facebook') {
    url = new FacebookURLBuilder(props).getUrl()
  } else if (type === 'LinkedIn') {
    url = new LinkedInURLBuilder(props).getUrl()
  } else if (type === 'Twitter') {
    url = new TwitterURLBuilder(props).getUrl()
  }

  return url
}
